export const PLACEHOLDERS = {
    DELIVERY_FEE: "{{del_fee}}",
    BASE_PRICE: "{{base_price}}",
};

export const OBJECT_VALUES = {
    CONFIRM: "confirm",
    DISMISS: "dismiss-popup",
};

/** This key is to store the Auto add XP plan type */
export const AUTO_ADD_OR_ONE_TAP_PLAN_TYPE_SESSION_KEY = "auto_add_or_one_tap_plan_session_key";
